module.exports = __webpack_public_path__ + "img/网站3-45.77b3432f.png";